import * as React from 'react';
import { SelectCourseOption } from '../styles';
import { Paper } from '../studentForm';

/**
 * DisplayPaper
 *
 * Displays a selectable course/paper option.
 * - Shows course code, name, and class.
 * - Allows toggling selection via checkbox or click.
 * - Calls addToSelectedCourse when selected/deselected.
 * - Resets selection state when the `reset` prop changes.
 *
 * Props:
 * - paper: The Paper object to display.
 * - addToSelectedCourse: Callback to add/remove this paper from selection.
 * - reset: Number that, when changed, resets the selection state.
 */
export const DisplayPaper: React.FC<{
  paper: Paper;
  addToSelectedCourse: (paper: Paper) => void;
  reset: number;
}> = ({ paper, addToSelectedCourse, reset }) => {
  // Local state to track if this paper is selected
  const [isSelected, setIsSelected] = React.useState(false);

  // Reset selection state when the reset prop changes
  React.useEffect(() => {
    setIsSelected(false);
  }, [reset]);

  return (
    <SelectCourseOption
      isChecked={isSelected}
      key={paper?._id}
      onClick={() => {
        if (paper) {
          addToSelectedCourse(paper);
          setIsSelected(!isSelected);
        }
      }}
    >
      {/* Checkbox reflects selection state, but onChange is only for logging */}
      <input
        type="checkbox"
        value={isSelected ? 'on' : 'off'}
        onChange={(e) => console.log(e.target.value)}
        checked={isSelected}
      />
      <h5>
        <b> {paper?.courseCode}, </b>
        {paper?.courseName} - {paper.class}
      </h5>
    </SelectCourseOption>
  );
};
